import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
const Privacidade = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Política de Privacidade | HabitFrog</title>
        <meta name="description" content="Conheça a Política de Privacidade do HabitFrog. Saiba como coletamos, usamos e protegemos seus dados pessoais em conformidade com a LGPD." />
        <link rel="canonical" href="https://habitfrog.com/privacidade" />
      </Helmet>

      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <article className="max-w-3xl mx-auto prose prose-lg">
            <h1 className="text-4xl font-display font-bold text-foreground mb-8">
              Política de Privacidade
            </h1>
            <p className="text-muted-foreground mb-4">Última atualização: Janeiro de 2026</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">1. Introdução</h2>
              <p className="text-foreground/80 mb-4">
                O HabitFrog está comprometido em proteger sua privacidade. Esta política descreve como coletamos, usamos e protegemos suas informações pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">2. Dados que Coletamos</h2>
              <p className="text-foreground/80 mb-4">Coletamos os seguintes tipos de dados:</p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li><strong>Dados de cadastro:</strong> nome, e-mail, senha (criptografada)</li>
                <li><strong>Dados de uso:</strong> hábitos criados, registros de conclusão, progresso</li>
                <li><strong>Dados técnicos:</strong> tipo de dispositivo, navegador, endereço IP</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">3. Como Usamos Seus Dados</h2>
              <p className="text-foreground/80 mb-4">Utilizamos seus dados para:</p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>Fornecer e melhorar nossos serviços</li>
                <li>Personalizar sua experiência no aplicativo</li>
                <li>Enviar notificações e lembretes de hábitos</li>
                <li>Comunicar atualizações importantes</li>
                <li>Prevenir fraudes e garantir segurança</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">4. Compartilhamento de Dados</h2>
              <p className="text-foreground/80 mb-4">
                <strong>Não vendemos seus dados.</strong> Compartilhamos informações apenas com:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>Provedores de serviço essenciais (hospedagem, pagamentos)</li>
                <li>Quando exigido por lei ou ordem judicial</li>
                <li>Com seu consentimento explícito</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">5. Seus Direitos (LGPD)</h2>
              <p className="text-foreground/80 mb-4">Você tem direito a:</p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incompletos ou incorretos</li>
                <li>Solicitar exclusão dos seus dados</li>
                <li>Revogar consentimento a qualquer momento</li>
                <li>Solicitar portabilidade dos dados</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">6. Segurança dos Dados</h2>
              <p className="text-foreground/80 mb-4">
                Implementamos medidas de segurança técnicas e organizacionais, incluindo: criptografia de dados em trânsito e em repouso, autenticação segura, monitoramento contínuo e backups regulares.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">7. Cookies</h2>
              <p className="text-foreground/80 mb-4">
                Usamos cookies essenciais para funcionamento do site e cookies analíticos para melhorar sua experiência. Você pode gerenciar preferências de cookies nas configurações do seu navegador.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">8. Retenção de Dados</h2>
              <p className="text-foreground/80 mb-4">
                Mantemos seus dados enquanto sua conta estiver ativa. Após exclusão da conta, os dados são removidos em até 30 dias, exceto quando exigido por lei.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">9. Contato do DPO</h2>
              <p className="text-foreground/80">
                Para exercer seus direitos ou esclarecer dúvidas sobre privacidade, entre em contato com nosso Encarregado de Proteção de Dados: privacidade@habitfrog.com
              </p>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacidade;
